import { Typography } from '@gds/Typography/Typography';
import { RichText } from '@page-builder/Components/RichText/RichText';
import { KenticoImage } from '@shared-components/KenticoImage/KenticoImage';

import type { UspItem } from 'Entities/UspContent.entity';

import styles from './ExtraUspItems.module.css';

export const ExtraUspItems = ({ items }: { items: UspItem[] }) => {
  return (
    <ul className={styles.extraUspItems}>
      {items.map(item => {
        return (
          <li key={item.title}>
            <div className={styles.titleContainer}>
              <div className={styles.icon}>
                <KenticoImage
                  src={item.image[0]}
                  alt={item.title}
                  fill
                  style={{ objectFit: 'contain' }}
                  sizes="(max-width: 768px) 20vw, (max-width: 1200px) 33vw"
                />
              </div>
              <Typography variant="h5" className={styles.mobileTitle}>
                {item.title}
              </Typography>
            </div>

            <div className={styles.typography}>
              <Typography variant="h5" className={styles.desktopTitle}>
                {item.title}
              </Typography>
              {item.description && (
                <Typography variant="body3" className={styles.description}>
                  {item.description}
                </Typography>
              )}
              {!item.description && <RichText richText={item.richDescription} />}
            </div>
          </li>
        );
      })}
    </ul>
  );
};
